import { useEffect, useState, useRef } from 'react';
import { useInView, animate } from 'framer-motion';

const CountUpAnimation = ({ target, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (inView) {
      const controls = animate(0, target, {
        duration: 2,
        ease: 'easeOut',
        onUpdate: (value) => {
          setDisplay(Math.floor(value));
        }
      });
      return controls.stop;
    }
  }, [inView, target]);

  return (
    <span ref={ref}>
      {display}
      {suffix}
    </span>
  );
};

export default CountUpAnimation;
